<ng-container *ngIf="productRequest">
    <capsule [label]="productRequest.status | prettifyProductRequestStatus" [backgroundColor]="productRequest.status | getProductRequestStatusColor" [small]="true"></capsule>
</ng-container>